import { useEffect, useState } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { FaEnvelope, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useFormik } from 'formik';
import InputField from '../FormFields/InputField';
import * as Yup from 'yup';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';


const SignUp = ({ onSignupSuccess, isActive }) => {

  const [errorMsg, setErrorMesssage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      fullName: '',
      email: '',
      mobile: '',
      password: '',
      confirmPassword: '',
      isDoctor:false,
      referenceNum:''
    },
    validationSchema: Yup.object({
      fullName: Yup.string()
        .required('Name is Required'),
      email: Yup.string()
        .required('Email is Required'),
      mobile: Yup.string()
        .required('Mobile number is Required'),
      password: Yup.string()
        .required('Password is Required'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),

      isDoctor: Yup.boolean(), // Still needed for `.when` reference
      /* referenceNum: Yup.string().when('isDoctor', {
        is: true,
        then: Yup.string().required('Reference Number is required'),
        otherwise: Yup.string().notRequired()
      }), */

    }),
    onSubmit: async (values, { setSubmitting }) => {
      let sign_resp = await signUp(values);
      if (sign_resp?.suc) {
        onSignupSuccess()
      } else {
        setErrorMesssage("Something went wrong!")
      }
      setSubmitting(false);
    }
  });

  useEffect(() => {
    if (isActive) {
      setErrorMesssage("");
      formik.resetForm();
    }
  }, [isActive]);

  const signUp = async (payload) => {
    //const response = await ApiService.post(APIS.SIGNUP_API, payload);
    let data = localStorage.getItem("signup");
    if (data !== undefined && data !== null && data !== "") {
      data = JSON.parse(data);
      let filter = data?.filter((itm) => itm?.email?.trim() === payload?.email?.trim());
      if (filter?.length == 0) {
        let itm_data = {
          fullName: payload?.fullName,
          email: payload?.email,
          isDoctor: payload?.isDoctor
        }
        data.push(itm_data);
      }
      localStorage.setItem("signup", JSON.stringify(data));
      toast.success("Registration done")
    } else {
      let data = [];
      let itm_data = {
        fullName: payload?.fullName,
        email: payload?.email,
        isDoctor: payload?.isDoctor
      }
      data.push(itm_data);
      localStorage.setItem("signup", JSON.stringify(data));
    }
    return {
      suc: true
    }
  }


  return (
    <Container className="mt-5 formWrap">
      <Row>
        <Col md={12}>
          <form onSubmit={formik.handleSubmit}>
            <div className='inputWrap'>
              <label>Full Name</label>
              <div className="input-group">
                <InputField
                  name="fullName"
                  placeholder="Enter full name"
                  type="text"
                  icon={FaEnvelope}
                  value={formik.values.fullName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.fullName}
                  touched={formik.touched.fullName}
                />
              </div>
            </div>
             <div className='inputWrap'>
              <label>Email</label>
              <div className="input-group">
                <InputField
                  name="email"
                  placeholder="Enter email"
                  type="text"
                  icon={FaEnvelope}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.email}
                  touched={formik.touched.email}
                />
              </div>
            </div>
              <div className='inputWrap'>
              <label>Mobile</label>
              <div className="input-group">
                <InputField
                  name="mobile"
                  placeholder="Enter mobile number"
                  type="text"
                  icon={FaEnvelope}
                  value={formik.values.mobile}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.mobile}
                  touched={formik.touched.mobile}
                />
              </div>
            </div>
            <div className='inputWrap'>
              <label>Password</label>
              <div className="input-group">
                <InputField
                  name="password"
                  placeholder="Enter Password"
                  type={showPassword ? 'text' : 'password'}
                  icon={showPassword ? FaEyeSlash : FaEye}
                  onIconClick={(e) => {
                    setShowPassword(prev => !prev);
                  }}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.password}
                  touched={formik.touched.password}
                />
              </div>
            </div>
             <div className='inputWrap'>
              <label>Confirm Password</label>
              <div className="input-group">
                <InputField
                  name="confirmPassword"
                  placeholder="Enter confirm password"
                  type={showPassword ? 'text' : 'password'}
                  icon={showPassword ? FaEyeSlash : FaEye}
                  onIconClick={(e) =>{
                    setShowPassword(prev => !prev);
                  }}
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.confirmPassword}
                  touched={formik.touched.confirmPassword}
                />
              </div>
            </div>
            <div className="checkbox-group">
              <label>
                <input
                  type="checkbox"
                  name="isDoctor"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.isDoctor}
                />
                I am a Doctor
              </label>
              {formik.touched.isDoctor && formik.errors.isDoctor && (
                <div className="error">{formik.errors.isDoctor}</div>
              )}
            </div>
            {formik?.values?.isDoctor &&
              <div className='inputWrap'>
                <label>Reference Number</label>
                <div className="input-group">
                  <InputField
                    name="referenceNum"
                    placeholder="Enter reference number"
                    type="text"
                    icon={FaEnvelope}
                    value={formik.values.referenceNum}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.errors.referenceNum}
                    touched={formik.touched.referenceNum}
                  />
                </div>
              </div>
            }

            <div className="buttonWrap">
              <Button variant="primary" type="submit">
                Sign Up
              </Button>
            </div>
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default SignUp;
